import { observable, action, reaction, computed, toJS, when, makeObservable } from 'mobx';
import axios from 'axios';
// import

class searchStore {
  blocks=[];
  locked_blocks=[];
  disable_focus=false;
  firstTimeFilter=true;

  par=null;
  constructor(par) {
    makeObservable(this,{
      blocks:observable,
      disable_focus:observable,
      locked_blocks:observable
    });
    this.par=par;
    when(
      ()=>{ return this.par.configStore.config.data.layout_marker; },
      ()=>{

        const loaded=this.loadLockedBlocks();
        if(loaded) {
          this.locked_blocks=loaded;
        }
        reaction(
          ()=>{
            return this.locked_blocks.length;
          },
          ()=>{
            this.saveLockedBlocks();
          }
        );

        reaction(()=>{
            return this.par.memoryStore.memory.filter;
          },(ret)=>{
            if(ret) {
              if(this.blocks.length === 0) {
                this.disable_focus=true;
              }

              const parsed=JSON.parse(ret);
              const deleteLen=this.blocks.length-parsed.length;
              for(let i in parsed) {
                if(typeof this.blocks[i] == "undefined") {
                  this.blocks.push({
                    code:parsed[i][0],
                    compare:parsed[i][1],
                    value:parsed[i][2],
                  });
                } else {
                  this.blocks[i].code=parsed[i][0];
                  this.blocks[i].compare=parsed[i][1];
                  this.blocks[i].value=parsed[i][2];
                }
              }
              if(deleteLen) {
                this.blocks.splice(parsed.length-1,deleteLen);
              }

              this.checkDefault();

              if(this.firstTimeFilter) {
                this.blocks[this.blocks.length - 1].focus = 1;
              }

              if(this.disable_focus) {
                setTimeout(()=>{
                  this.disable_focus=false;
                  console.log("focus last!");

                },300);
              } else {


              }

              console.log('blocks',toJS(this.blocks));
            }
          },{ fireImmediately:true });

        this.checkDefault();

          reaction(()=>{
            return toJS(this.blocks);
          },()=>{
            const list=this.blocks.map((item)=>{
              return [item.code, item.compare, item.value];
            });
            this.par.memoryStore.setFilter(JSON.stringify(list),this.firstTimeFilter);
            this.firstTimeFilter=false;
            this.par.communicatorStore.pushMessage({ type:"output", command:"filter_changed", data:{ blocks:toJS(this.blocks) } });
          },{ delay: 300 });


      }
    )


    window.setSimpleFilter=(ob)=>{ this.setSimpleFilter(ob); };
  }
  getCompare(field) {
    if (field.compare) {
      return field.compare;
    }
    if (field.filter_type === "string") {
      return '~';
    }
    return '=';
  }
  getDefaultFilter() {
    const defCode=this.par.configStore.config.data.default_filter || "name";
    console.log('def_code',defCode);
    for(let i in this.par.configStore.config.data.fields) {
      const cur=this.par.configStore.config.data.fields[i];
      if(cur.code === defCode && cur.filter_type) {
        return {
          code: defCode,
          compare: this.getCompare(cur),
          value: "",
          default: 1,
        }
      }
    }
    return null;
  }
  checkDefault() {
    const def = this.getDefaultFilter();/* = {
      code: "name",
      compare: "~",
      value: "",
      default: 1,
    };*/
    console.log('def_code',def);
    if(!def) {
      return false;
    }


    let defIndex=-1;
    for(let i in this.blocks) {
      if(this.blocks[i].code == def.code && this.blocks[i].compare == def.compare) {
        defIndex=parseInt(i);
        if(!this.blocks[i].default) {
          this.blocks[i].default=1;
        }
        break;
      } else {
        if(this.blocks[i].default) {
          this.blocks[i].default=0;
        }
      }
    }
    if(defIndex === -1) {
      console.log('defIndex = -1');
      this.blocks.unshift(def);
    } else {
      if(defIndex > 0) {
        console.log('defIndex > 0');
        const spliced=this.blocks.splice(defIndex,1)[0];
        spliced.default=1;
        this.blocks.unshift(spliced);
      }
    }
    console.log('def blocks',toJS(this.blocks));

  }
  loadLockedBlocks() {
    if(typeof localStorage !== 'undefined') {
      const marker = this.par.configStore.config.data.layout_marker;
      const loaded=localStorage.getItem(`eva_lb_${marker}`);
      if(loaded) {
        return JSON.parse(loaded);
      }
    }
    return false;
  }
  saveLockedBlocks() {
    if(typeof localStorage !== 'undefined') {
      const marker=this.par.configStore.config.data.layout_marker;
      if(this.locked_blocks.length>0) {
        localStorage.setItem(`eva_lb_${marker}`, JSON.stringify(toJS(this.locked_blocks)));
      } else {
        localStorage.removeItem(`eva_lb_${marker}`);
      }
    }
  }
  setSimpleFilter(ob) {
    for(let i in ob) {
      const arg=i.matchAll(/([<>=!~]?[=]?)(.+)/gi).next();
      if(arg.value && arg.value[2]) {
         this.findAndSetBlock({
          code:arg.value[2],
          compare:arg.value[1]?arg.value[1]:'=',
          value:ob[i]?(ob[i]+""):"",
        });
      } else {

      }

    }
  }
  findAndSetBlock(ob) {
    let was=false;
    for(let i in this.blocks) {
      if(this.blocks[i].code === ob.code && this.blocks[i].compare === ob.compare) {
        if(ob.value) {
          this.blocks[i].value = ob.value;
        } else {
          this.blocks.splice(parseInt(i),1);
        }
        was=true;
        break;
      }
    }
    if(!was) {
      if(ob.value) {
        this.blocks.push(ob);
      }
    }
  }
  isRange(val) {
    const match=val.matchAll(/(-?[0-9.]+)-(-?[0-9.]+)/g).next();
    if(match.value) {
      return [match.value[1],match.value[2]];
    }
  }
  getDaysInMonth(month,year) {
    return new Date(parseInt(year), parseInt(month), 0).getDate();
  }
  convertValueToType(value, type) {
    if(this.par.configStore.config.data.preserve_types) {
      if(type === "integer" || type === "select_yes_no") {
        return parseInt(value);
      }
      if(type === "decimal") {
        return parseFloat(value);
      }
    }
    return value;
  }
  addPrefixPostfix(prefix, postfix, value) {
    if(prefix || postfix) {
      return prefix+value+postfix;
    }
    return value;
  }
  getFilter() {
    let iReturn={};
    const allBlocks=[this.locked_blocks,this.blocks];
    for(let k in allBlocks) {
      for (let i in allBlocks[k]) {
        const cur = allBlocks[k][i];
        const field = this.par.configStore.fields_by_code[cur.code];
        let prefix = field ? (field.prefix_search || '') : '';
        let postfix = field ? (field.postfix_search || '') : '';

        if (cur.value) {
          if (field.filter_type === 'date') {
            const matches = cur.value.matchAll(/([0-9]+)-?([0-9]+)?-?([0-9]+)? ?([0-9]+)?:?([0-9]+)?:?([0-9]+)?/gi).next().value
            // console.log('matches', matches, cur.value);
            if(typeof matches !== 'undefined') {
              if (cur.compare === '>=' || cur.compare === '<') {
                if (!matches[6]) {
                  matches[6] = '00';
                }
                if (!matches[5]) {
                  matches[5] = '00';
                }
                if (!matches[4]) {
                  matches[4] = '00';
                }
                if (!matches[2]) {
                  matches[2] = '01';
                }
                if (!matches[3]) {
                  matches[3] = '01';
                }
                if (!matches[1]) {
                  matches[1] = '0000';
                }
              }
              if (cur.compare === '>' || cur.compare === '<=') {
                if (!matches[6]) {
                  matches[6] = '59';
                }
                if (!matches[5]) {
                  matches[5] = '59';
                }
                if (!matches[4]) {
                  matches[4] = '23';
                }
                if (!matches[2]) {
                  matches[2] = '12';
                }
                if (!matches[1]) {
                  matches[1] = '0000';
                }
                if (!matches[3]) {
                  matches[3] = this.getDaysInMonth(matches[2], matches[1]);
                }
              }
              if (cur.compare === '=' || cur.compare === '!=') {
                const min = [];
                const max = [];

                if (!matches[6]) {
                  max[6] = '59';
                  min[6] = '00';
                } else {
                  max[6] = matches[6];
                  min[6] = matches[6];
                }
                if (!matches[5]) {
                  max[5] = '59';
                  min[5] = '00';
                } else {
                  max[5] = matches[5];
                  min[5] = matches[5];
                }
                if (!matches[4]) {
                  max[4] = '23';
                  min[4] = '00';
                } else {
                  max[4] = matches[4];
                  min[4] = matches[4];
                }

                if (!matches[2]) {
                  max[2] = '12';
                  min[2] = '01';
                } else {
                  max[2] = matches[2];
                  min[2] = matches[2];
                }
                if (!matches[1]) {
                  max[1] = '9999';
                  min[1] = '0000';
                } else {
                  max[1] = matches[1];
                  min[1] = matches[1];
                }
                if (!matches[3]) {
                  max[3] = this.getDaysInMonth(max[2], max[1]);
                  min[3] = '01';
                } else {
                  max[3] = matches[3];
                  min[3] = matches[3];
                }

                const valMin = `${min[1]}-${min[2]}-${min[3]} ${min[4]}:${min[5]}:${min[6]}`;
                const valMax = `${max[1]}-${max[2]}-${max[3]} ${max[4]}:${max[5]}:${max[6]}`;

                console.log('EQ CHECK min', min);
                console.log('EQ CHECK max', max);
                console.log('EQ CHECK matches', matches);
                if(cur.compare === '!=') {
                  iReturn['><' + cur.code] = [valMin,valMax];
                  // iReturn['>' + cur.code] = ;
                } else {
                  iReturn['>=' + cur.code] = valMin;
                  iReturn['<=' + cur.code] = valMax;
                }
              }

              if (cur.compare === '>=' || cur.compare === '<' || cur.compare === '>' || cur.compare === '<=') {
                const val = `${matches[1]}-${matches[2]}-${matches[3]} ${matches[4]}:${matches[5]}:${matches[6]}`;
                iReturn[cur.compare + cur.code] = val;
              }
            }

            continue;
          }
          if (cur.compare === '=') {
            if (field.filter_type === "integer" || field.filter_type === "decimal") {
              const range = this.isRange(cur.value);
              if (range) {
                iReturn['>=' + cur.code] = this.convertValueToType(range[0], field.filter_type);
                iReturn['<=' + cur.code] = this.convertValueToType(range[1], field.filter_type);
              } else {
                if (!iReturn[cur.code]) {
                  iReturn[cur.code] = [];
                }
                iReturn[cur.code].push(this.addPrefixPostfix(prefix, postfix, this.convertValueToType(cur.value, field.filter_type)));
              }
            } else {
              if (!iReturn[cur.code]) {
                iReturn[cur.code] = [];
              }
              iReturn[cur.code].push(this.addPrefixPostfix(prefix, postfix, this.convertValueToType(cur.value, field.filter_type)));
            }
          }
          if (cur.compare === '!=' || cur.compare === '>=' || cur.compare === '<=' || cur.compare === '>' || cur.compare === '<') {
            if (!iReturn[cur.compare + cur.code]) {
              iReturn[cur.compare + cur.code] = [];
            }
            iReturn[cur.compare + cur.code].push(this.addPrefixPostfix(prefix, postfix,this.convertValueToType(cur.value, field.filter_type)));
          }
          if (cur.compare === '~') {
            if (!iReturn['~' + cur.code]) {
              iReturn['~' + cur.code] = [];
            }
            if(this.par.configStore.config.data.disable_str_mask) {
              iReturn['~' + cur.code].push(this.addPrefixPostfix(prefix, postfix, this.convertValueToType(cur.value, field.filter_type)));
            } else {
              iReturn['~' + cur.code].push('%' + this.addPrefixPostfix(prefix, postfix, cur.value.replace(/\ /gi, "%")) + '%');
            }
            // iReturn['~' + cur.code].push('%' + prefix + cur.value.replace(/\ /gi, "%") + postfix + '%');
          }
        }
      }
    }
    return iReturn;
  }
}

/*decorate(searchStore,{
  blocks:observable,
  disable_focus:observable,
  locked_blocks:observable
});*/

export default searchStore;
